module.exports = __webpack_public_path__ + "img/pick3.1de64850.png";